/* ============================================================
   EB · Custom Apparel — Edit-Mode Label Patch
   Small companion to custom-apparel.js.
   Adds "Update Order" label handling when arriving from
   Cart → Edit This Job, without touching the main file.

   Reads:
     - data-edit-label attribute on the ATC button (defined in
       blocks/bulk-atc.liquid, default "Update Order")
     - sessionStorage.sixsis_edit_order (set by cart when
       user clicks Edit This Job)

   Effects:
     - When ?edit=1 is in URL AND edit payload exists, sets
       custom-apparel-form[data-editing="true"] on the form.
     - After the main script computes the ATC label, we ensure
       the button text and success/loading label restoration use
       the edit label while data-editing="true".

   Load order: after custom-apparel.js (both defer, this script
   ordered after in DOM).
   ============================================================ */
(function () {
  'use strict';

  const EDIT_KEY = 'sixsis_edit_order';

  function markEditMode() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('edit') !== '1') return false;
    try {
      const payload = window.sessionStorage.getItem(EDIT_KEY);
      if (!payload) return false;
    } catch (_) {
      return false;
    }
    const form = document.querySelector('custom-apparel-form');
    if (!form) return false;
    form.dataset.editing = 'true';
    return form;
  }

  function editLabelFor(form) {
    const btn = form.querySelector('[data-ca-atc]');
    if (!btn) return null;
    return btn.getAttribute('data-edit-label') || 'Update Order';
  }

  function applyEditLabel(form) {
    const btn = form.querySelector('[data-ca-atc]');
    if (!btn) return;
    const label = editLabelFor(form);
    if (label) btn.textContent = label;
  }

  function watchLabel(form) {
    const btn = form.querySelector('[data-ca-atc]');
    if (!btn) return;
    // Whenever the main script rewrites the button text, if we're
    // in edit mode and the text matches the default label, swap it
    // to the edit label. We use a MutationObserver on characterData
    // + childList to catch textContent updates.
    const defaultLabel = btn.getAttribute('data-label') || 'Add to Cart';
    const editLabel = btn.getAttribute('data-edit-label') || 'Update Order';

    const swap = () => {
      if (form.dataset.editing !== 'true') return;
      if (btn.disabled) return; // Let disabled states (Adding..., Success!, etc.) show as-is
      // Only swap the default Add to Cart label — leave dynamic states alone
      const txt = (btn.textContent || '').trim();
      if (txt === defaultLabel && editLabel !== defaultLabel) {
        btn.textContent = editLabel;
      }
    };

    const mo = new MutationObserver(swap);
    mo.observe(btn, { childList: true, characterData: true, subtree: true });

    // Also swap once immediately after main script initializes
    setTimeout(swap, 0);
    setTimeout(swap, 100);
    setTimeout(swap, 500);
  }

  function init() {
    const form = markEditMode();
    if (!form) return;
    applyEditLabel(form);
    watchLabel(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
